import { render, staticRenderFns } from "./securityTest.vue?vue&type=template&id=d6200f76&scoped=true"
import script from "./securityTest.vue?vue&type=script&lang=js"
export * from "./securityTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6200f76",
  null
  
)

export default component.exports